import * as React from 'react';

import SearchInput from 'af-components/Controls/SearchInput';

import GroupEntriesLoading from './GroupEntriesLoading';
import GroupEntry from './GroupEntry';
import styles from './styles.module.scss';

interface Group {
	name: string;
}

interface OwnProps {
	isLoading: boolean;
	search: string;
	groups: Nullable<Group[]>;
	selectedGroup: Nullable<string>;
	onSelect: (group: string) => void;
	onSearchChange: (search: string) => void;
}

type Props = OwnProps;

const GroupList: React.FC<Props> = (props: Props) => {
	const { groups, selectedGroup, onSelect, search, onSearchChange, isLoading } = props;

	const renderGroup = React.useCallback((group: Group) => {
		return (
			<GroupEntry
				groupName={group.name}
				isSelected={selectedGroup === group.name}
				key={group.name}
				onClick={onSelect}
			/>
		);
	}, [onSelect, selectedGroup]);

	const filteredGroups = React.useMemo(() => {
		if (!groups) {
			return [];
		}
		if (!search) {
			return groups;
		}
		return groups.filter((_group) => _group.name.toLowerCase().includes(search.toLowerCase()));
	}, [groups, search]);

	const groupsNode = !isLoading ? filteredGroups.map(renderGroup) : <GroupEntriesLoading />;

	return (
		<div className={styles.GroupList}>
			<div className={styles.inputContainer}>
				<SearchInput
					onChange={onSearchChange}
					placeholder="Search"
					value={search}
				/>
			</div>
			{
				(!isLoading && !groups?.length)
					? (
						<div className={styles.listEmpty}>
							<div className={styles.emptyDescription}>No groups found.</div>
						</div>
					) : (
						<div className={styles.list}>
							{groupsNode}
						</div>
					)
			}
		</div>
	);
};

export default React.memo(GroupList);
